"use client";

import { useEffect } from "react";

// In-app browsers (Google app, Facebook, Instagram, generic Android WebViews)
// have flaky service-worker support that can leave the page stuck on a black
// screen. Skip SW registration there — the site works fine without it, and the
// real installed PWA (standalone Chrome) is unaffected.
function isInAppBrowser(ua: string): boolean {
  return /\bGSA\/|FBAN|FBAV|Instagram|Line\/|\bwv\)/i.test(ua);
}

export function PwaRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
      return;
    }
    // /diag is the self-repair page: it must never (re-)install a worker while
    // the user is there trying to get rid of one.
    if (window.location.pathname.startsWith("/diag")) {
      return;
    }
    if (isInAppBrowser(navigator.userAgent)) {
      // Also proactively clear any stuck registration from a previous visit.
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((reg) => reg.unregister()))
        .catch(() => {});
      return;
    }

    const register = async () => {
      try {
        await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      } catch (error) {
        console.error("Service worker registration failed:", error);
      }
    };

    window.addEventListener("load", register);
    return () => window.removeEventListener("load", register);
  }, []);

  return null;
}
